// extracted by mini-css-extract-plugin
export default {"companyContainer":"XM-z","companyImage":"YM-z","container":"ZM-z","heading":"_M-z","darkText":"aN-z","smallHeading":"bN-z","darkBackground":"cN-z","whiteBackground":"dN-z"};